export default __webpack_public_path__ + "d64d45695bd4bf11f3ae9d0583f684e7.png";